import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M16.307 4.082a.752.752 0 01-.04.047l-2.972 3.14a.75.75 0 01-.801.19L4.693 4.622 3.427 5.887 9.416 9.88a.75.75 0 01.114 1.154l-2.25 2.25a.75.75 0 01-.53.22H4.81L3.636 14.68l2.773.935a.75.75 0 01.471.47l.944 2.785L9 17.693v-1.94a.75.75 0 01.22-.53l.76-.759a.75.75 0 111.06 1.06l-.54.54v1.94a.75.75 0 01-.22.53l-2.25 2.25a.75.75 0 01-1.24-.29l-1.212-3.576-3.568-1.203a.75.75 0 01-.29-1.241l2.25-2.25a.75.75 0 01.53-.22h1.94l1.383-1.383-5.989-3.993a.75.75 0 01-.114-1.154l2.25-2.25a.75.75 0 01.786-.175l7.788 2.832 2.474-2.615a.752.752 0 01.108-.136 3.004 3.004 0 014.304 4.192l-.055.055v.001a.757.757 0 01-.064.056L16.264 10.3a.75.75 0 11-1.028-1.092l3.117-2.931a1.504 1.504 0 00-2.046-2.195z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.26 13.504v7.5h6V15.69l-2.186-2.186h-3.815zm-1.171-1.17c.21-.212.497-.33.795-.33h4.5a.75.75 0 01.53.22l2.626 2.625c.14.14.22.331.22.53v6a1.125 1.125 0 01-1.126 1.125h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.298.119-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M18.384 12.004a.75.75 0 01.75.75v1.875h1.875a.75.75 0 010 1.5h-2.625a.75.75 0 01-.75-.75v-2.625a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
